import { FC } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Chip, Stack } from '@mui/material';

type Props = {
  length: number;
  isMenuOpen: boolean;
};

const FilterButtonIcon: FC<Props> = ({ length, isMenuOpen }) => (
  <Stack gap={1} direction="row" alignItems="center">
    {length > 0 ? <Chip label={length} color="primary" size="small" /> : null}
    {isMenuOpen ? <ExpandLess /> : <ExpandMore />}
  </Stack>
);

export default FilterButtonIcon;
